module.exports = __webpack_public_path__ + "img/r_1.2392325a.gif";